import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

// API PascalCase döner (Startup.cs: PropertyNamingPolicy = null).
export interface ICardPhoneSetting {
  Modul: string
  Data: string | null
}

/**
 * Kart-telefon SMS doğrulama ayarları. Backend tarafında modül adı whitelist'e
 * karşı doğrulanır; bu uç genel bir TableSiteStructures yazıcısı değildir.
 */
export class CardPhoneSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async getSettings(): Promise<ICardPhoneSetting[]> {
    this.props.url = 'admin/cardPhoneBinding/settings'
    return await this.getAsync<ICardPhoneSetting[]>()
  }

  /** Ayarların tamamı tek istekte kaydedilir; sunucu tarafında tek SaveChanges. */
  public async saveSettings(settings: ICardPhoneSetting[]): Promise<boolean> {
    this.props.url = 'admin/cardPhoneBinding/settings/save'
    return await this.postAsync<boolean>(
      settings.map(s => ({ Modul: s.Modul, Data: s.Data || '' }))
    )
  }
}

/**
 * Aç/Kapa ile yönetilen ayarlar. Saklanan değer HAM 'true' / 'false' metnidir —
 * UI'da ters çevirme YOK. SavedCardExempt'te true "muaf" demek olduğu için
 * seçenek etiketleri değerin ne yaptığını anlatır, adını değil.
 */
export const CARD_PHONE_BOOLEAN_OPTIONS: Record<string, { value: string; label: string }[]> = {
  CardPhoneVerificationEnabled: [
    { value: 'true', label: 'Açık' },
    { value: 'false', label: 'Kapalı' },
  ],
  CardPhoneVerificationSavedCardExempt: [
    { value: 'true', label: 'Kapalı — kayıtlı kartlar muaf (varsayılan)' },
    { value: 'false', label: 'Açık — kayıtlı kartlarda da doğrulama istenir' },
  ],
}

/** Şirket listesinden çoklu seçimle yönetilen ayar. Değer virgüllü şirket kodu listesi. */
export const CARD_PHONE_COMPANY_SETTING = 'CardPhoneVerificationCompanies'

/**
 * Datagate (1100) için doğrulamayı KULLANAN bayi segmentleri. Vodafone = TableDealers.IsVodafone 1,
 * Mix = diğerleri. Değer virgüllü segment listesi; boş kaydedilirse hiçbir Datagate bayisinde
 * doğrulama istenmez. Ayar hiç kaydedilmemişse (null) ikisi de kullanır — ekran bu durumda iki
 * seçeneği de seçili gösterir ki ilk kayıt davranışı değiştirmesin.
 */
export const CARD_PHONE_DATAGATE_SEGMENT_SETTING = 'CardPhoneVerificationDatagateSegments'

export const CARD_PHONE_DATAGATE_SEGMENT_OPTIONS: { value: string; label: string }[] = [
  { value: 'Vodafone', label: 'Datagate - Vodafone' },
  { value: 'Mix', label: 'Datagate - Mix' },
]

/** Ekranda gösterilen Türkçe başlıklar. Sıra, ekrandaki sıradır. */
export const CARD_PHONE_SETTING_TITLES: Record<string, string> = {
  CardPhoneVerificationEnabled: 'GENEL AÇ/KAPA — kapalıyken hiçbir şirkette çalışmaz',
  CardPhoneVerificationCompanies: 'Açık Şirketler (boş ise hiçbir şirkette çalışmaz)',
  CardPhoneVerificationDatagateSegments:
    'Datagate Segmentleri — doğrulamayı kullanan bayiler (Datagate açık şirketlerdeyse geçerli)',
  CardPhoneVerificationSavedCardExempt: 'Kayıtlı Kartlarda Doğrulama',
  CardPhoneVerificationLinkMinutes: 'Link Geçerlilik (dk)',
  CardPhoneVerificationCodeMinutes: 'Kod Geçerlilik (dk)',
  CardPhoneVerificationMaxCodeAttempts: 'Yanlış Kod Hakkı',
  CardPhoneVerificationResendMinutes: 'Yeniden Gönderme Aralığı (dk)',
}
